module.exports = __webpack_public_path__ + "img/file.69bcab52.png";